import Carousel from "./Carousel";
import PropTypes from "prop-types";

export const Mission = (props) => {
  const carouselItems = [
    {
      id: 1,
      title:
        "Курсы повышения квалификации педагогов дошкольных организаций с целью повышения эффективности учебно-воспитательного и управленческого процесса в г. Алматы",
    },
    {
      id: 2,
      title:
        "Курсы повышения квалификации школьных команд в рамках проекта «Успешная школа: управление качеством обучения через школьную команду» в г. Алматы",
    },
    {
      id: 3,
      title:
        "«Комплексная методическая поддержка организации образования с целью повышения эффективности учебно-воспитательного процесса» в Карагандинской области в рамках проекта ОФ «Қазақстан халқына»",
    },
    {
      id: 4,
      title:
        "Курсы повышения квалификаций педагогов организаций среднего образования в рамках проекта «Целевые школы» в Карагандинской области",
    },
    {
      id: 5,
      title:
        "Курсы повышения квалификаций педагогов организаций среднего образования в рамках проекта «Целевые школы» в Алматинской области",
    },
    {
      id: 6,
      title:
        "Курсы повышения квалификаций педагогов организаций среднего образования в рамках проекта «Целевые школы» в области Жетісу",
    },
    {
      id: 7,
      title:
        "Внедрение опыта лицеев «Білім-Инновация» в школах Алматинской области в рамках проекта ОФ «Қазақстан халқына»",
    },
  ];

  const CustomCard = ({ item }) => (
    <div className="border border-[#01333E] rounded-lg shadow-md p-4 h-80 flex flex-col justify-between text-[#01333E]">
      <h3 className="text-sm font-bold">{item.title}</h3>
      <p className="text-xs">{item.content}</p>
    </div>
  );
  CustomCard.propTypes = {
    item: PropTypes.shape({
      id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
      title: PropTypes.string,
      content: PropTypes.string,
    }).isRequired,
  };

  return (
    <div
      id="projectsCard"
      className="container max-w-6xl mx-auto py-10 mt-10 font-montserrat"
    >
      <h1 className="text-3xl font-bold text-center px-6">
        Наша работа в цифрах
      </h1>
      <h2 className="text-md text-center mt-6 mb-2 px-6">
        Более 15 лет опыта работы в сфере образования
      </h2>
      <h2 className="text-md text-center mt-2 mb-8">
        20 000+ слушателей курсов
      </h2>

      <Carousel items={carouselItems.slice(0, 7)} CardComponent={CustomCard} />
    </div>
  );
};

export default Mission;
